/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { FC } from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { MasterLayout } from '../../cms/layout/MasterLayout'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from '../modules/auth'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { RootState } from '../../setup'
import { MasterInit } from '../../cms/layout/MasterInit'
import { NewPassword } from '../modules/auth/components/NewPassword'
import Callback from '../modules/auth/Callback'
import { FallbackView } from '../../cms/partials'
const applicationTypeName = window.__RUNTIME_CONFIG__.REACT_APP_NAME

// Standalone docs site: rendered OUTSIDE MasterLayout (own chrome) and outside
// PrivateRoutes' menu-alias gate. The page itself enforces the superadmin role.
const CoreDocsPage = React.lazy(() => import('../modules/coreDocs'))

const Routes: FC = () => {
  const isAuthorized = useSelector<RootState>(({ auth }) => auth.user, shallowEqual)
  return (
    <>
      <Switch>
        {!isAuthorized ? (
          /*Render auth page when user at `/auth` and not authorized.*/
          <Route>
            <AuthPage />
          </Route>
        ) : (
          /*Otherwise redirect to root page (`/`)*/
          // <Redirect from='/auth' to='/' />
          <Redirect from='/sso' to='/' />
        )}

        <Route path='/error' component={ErrorsPage} />
        <Route path='/signout-callback-oidc' component={Logout} />

        {isAuthorized && (
          <Route path='/core/docs'>
            <React.Suspense fallback={<FallbackView />}>
              <CoreDocsPage />
            </React.Suspense>
          </Route>
        )}

        {!isAuthorized ? (
          /*Redirect to `/auth` when user is not authorized*/
          <Redirect to='/' />
        ) : (
          <>
            <MasterLayout>
              <PrivateRoutes />
            </MasterLayout>
          </>
        )}
      </Switch>
      <MasterInit />
    </>
  )
}

export { Routes }
